
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]",
      function () {
        return require("private-next-pages/[region]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]"])
      });
    }
  